import React, { forwardRef } from 'react';
import { PopupMenu } from 'shared/components/ui/popup-menu';
import { InteractionType } from 'shared/types/data-type';
import { TimeFormatOptions } from 'shared/types/date-format-options';
import { Timeslot } from 'shared/types/timeslot';

import { TimeRangeForm } from './time-range-form';

export type TimeRangeContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'ref' | 'onOutside' | 'interactionType'
> & {
  value?: Timeslot | null;
  onChange: (value: Timeslot | null) => void;
  onClose: () => void;
  timeFormat: TimeFormatOptions;
};

export const TimeRangeContextMenu = forwardRef<
  HTMLDivElement,
  TimeRangeContextMenuProps
>(
  (
    { value, onChange, timeFormat, onClose, position = 'bottom-end', ...rest },
    ref,
  ) => {
    const _onChange = (value: Timeslot | null) => {
      onChange(value);
      onClose();
    };

    return (
      <PopupMenu
        {...rest}
        ref={ref}
        interactionType={InteractionType.Task}
        onOutside={onClose}
        position={position}
      >
        <TimeRangeForm
          initialValue={value}
          timeFormat={timeFormat}
          onChange={_onChange}
        />
      </PopupMenu>
    );
  },
);
